import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditAnalysis } from './ModalCreditAnalysis.styles';

export default function ModalCreditAnalysis({ showCreditModal, setShowCreditModal }) {
  const navigate = useNavigate();

  const closeModal = () => setShowCreditModal(false);

  const handleNav = () => {
    setShowCreditModal(false);
    navigate('/solicitante/dashboard');
  };

  return (
    <CreditAnalysis showCreditModal={showCreditModal}>
      <div>
        <figure onClick={handleNav}>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
            alt="icono para cerrar la ventana"
          />
        </figure>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
            alt="icono de aviso"
          />
        </figure>
        <h2>Validación crediticia finalizada</h2>
        <p>
          Lamentablemente la validación que realizamos no cumplió con el requerimiento de para
          solicitud de crédito, sin embargo aún podemos evaluar tu información mediante nuestro
          apartado de contacto.
        </p>
        <button>Ir a contacto</button>
        <button onClick={handleNav}>Salir</button>
      </div>
    </CreditAnalysis>
  );
}
